import React, {useState} from 'react';
import {Image, StyleSheet, Text, TouchableOpacity, View} from 'react-native';
import {BORDER_COLOR, HEADER_TITLE_COLOR, PRIMARY_BACKGROUND_COLOR} from "../../Config/Colors";
import ProxyIcon from "../../Images/Icons/proxy.png";
import ClientsIcon from "../../Images/Icons/clients.png";
import {MAIN_MENU_BORDER_WIDTH, SCREEN_HEIGHT, SCREEN_WIDTH, WINDOW_WIDTH} from "../../Config/Constants";
import SubViewTypes from "../../Domain/Types/SubViewTypes";
import UrbanIcon from "../../Images/Icons/Urban.png";
import {START_PAGE} from "../../Config/Parameters";

interface MainMenuProps
{
    /**
     * Callback when an option was selected.
     * @param subViewTypes The selected option.
     */
    onOptionSelected?: (subViewTypes: SubViewTypes) => void;
}

/**
 * Renders the Main Menu.
 */
export default function MainMenu({
    onOptionSelected,
}: MainMenuProps)
{
    const [current, setCurrent] = useState(START_PAGE);
    
    const onButtonPressed = (type: SubViewTypes): void =>
    {
        if (onOptionSelected !== undefined)
        {
            onOptionSelected(type);
            setCurrent(type);
        }
    }

    const getBackgroundColor = (type: SubViewTypes): string =>
    {
        return (current === type) ? BORDER_COLOR : "transparent";
    }
    
    return (
        <View style={styles.container}>
            <View style={styles.titleView}>
                <Text style={styles.titleText}>
                    {`Dashboards`}
                </Text>
            </View>
            
            <TouchableOpacity
                onPress={() => onButtonPressed(SubViewTypes.PowerClient)}
                style={[styles.saveClientNameButton, {
                    backgroundColor: getBackgroundColor(SubViewTypes.PowerClient)
                }]}
            >
                <Image
                    source={ClientsIcon}
                    resizeMode={"contain"}
                    style={styles.icon}
                />

                <Text style={styles.updateButtonText}>
                    Power Clients
                </Text>
            </TouchableOpacity>

            <TouchableOpacity
                onPress={() => onButtonPressed(SubViewTypes.PowerProxy)}
                style={[styles.saveClientNameButton, {
                    backgroundColor: getBackgroundColor(SubViewTypes.PowerProxy)
                }]}
            >
                <Image
                    source={ProxyIcon}
                    resizeMode={"contain"}
                    style={styles.icon}
                />

                <Text style={styles.updateButtonText}>
                    Power Proxies
                </Text>
            </TouchableOpacity>

            <View style={styles.logoView}>
                <Image
                    source={UrbanIcon}
                    resizeMode={"contain"}
                    style={styles.logo}
                />
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: PRIMARY_BACKGROUND_COLOR,
        width: '100%',
        height: '100%',
        alignItems: 'center',
        alignContent: 'center',
        borderWidth: MAIN_MENU_BORDER_WIDTH,
        borderColor: BORDER_COLOR,
        borderRightColor: 'transparent',
        borderRightWidth: 0,
    },
    titleView: {
        height: '7%',
        width: '80%',
        justifyContent: 'center',
        borderWidth: 5,
        borderBottomColor: BORDER_COLOR,
        borderTopColor: 'transparent',
        borderLeftColor: 'transparent',
        borderRightColor: 'transparent',
        borderRightWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },
    titleText: {
        color: HEADER_TITLE_COLOR,
        fontSize: WINDOW_WIDTH * 0.015,
        fontWeight: "600",
        textAlign: 'left',
        paddingTop: '10%',
    },
    saveClientNameButton: {
        marginTop: '10%',
        width: '90%',
        height: '5%',
        borderRadius: SCREEN_HEIGHT * 0.005,
        alignItems: 'center',
        justifyContent: 'flex-start',
        paddingLeft: '5%',
        flexDirection: 'row',
    },
    icon: {
        width: undefined,
        height: '55%',
        tintColor: HEADER_TITLE_COLOR,
        aspectRatio: 1,
        marginRight: '5%',
    },
    logoView: {
        position: 'absolute',
        paddingTop: '12%',
        bottom: 0,
        width: '80%',
        height: '10%',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    logo: {
        width: "100%",
        height: '100%',
        tintColor: HEADER_TITLE_COLOR,
        aspectRatio: 1,
    },
    updateButtonText: {
        textAlign: 'center',
        alignSelf: 'center',
        fontSize: SCREEN_WIDTH * 0.014,
        color: HEADER_TITLE_COLOR,
        fontWeight: '600',
    },
});
